import { useEffect, useRef } from "react";
import { getSocket } from "../services/socket";

export function useLiveCurrency(symbols, onUpdate) {
  const subscribedRef = useRef(new Set());

  useEffect(() => {
    if (!symbols?.length) return;
    const socket = getSocket();

    const subscribeAll = () => {
      symbols.forEach((s) => {
        if (!subscribedRef.current.has(s)) {
          socket.emit("currency:subscribe", { symbol: s });
          subscribedRef.current.add(s);
        }
      });
    };

    if (socket.connected) subscribeAll();
    socket.on("connect", subscribeAll);

    const handleUpdate = (data) => onUpdate(data);
    socket.on("currency:liveUpdate", handleUpdate);

    return () => {
      socket.off("connect", subscribeAll);
      socket.off("currency:liveUpdate", handleUpdate);
      // if this symbol list is going away for good, you could emit an unsubscribe here
    };
  }, [symbols, onUpdate]);
}